import {useMenubarKeyPress} from "./useMenubarKeyPress";
import {ElevationApp} from "../ElevationApp";

// Ctrl/Cmd+Z = undo, Ctrl/Cmd+Shift+Z and Ctrl/Cmd+Y = redo. Registered directly on
// useMenubarKeyPress (not useMenubarShortcuts, whose matcher deliberately skips
// modifier chords) so the field-focus guard still applies: Ctrl+Z inside a dimension
// input keeps the input's native text undo. The app-wide UndoProvider
// (misc/scroller/GlobalUndo.tsx, mounted via Container) also listens for Ctrl+Z on
// document.body, but nothing in the elevation tool pushes to it, so it no-ops and
// never preventDefaults — no double-handling.
export function useUndoRedoShortcuts(app: ElevationApp | null | undefined) {
    useMenubarKeyPress(e => {
        if(!app) return;

        const mod = e.metaKey || e.ctrlKey;
        if(!mod || e.altKey) return;

        // e.key is "Z" when shift is held
        const key = e.key.toLowerCase();
        if(key === "z" && !e.shiftKey) {
            e.preventDefault();
            app.history.undo();
            return;
        }
        if(key === "z" && e.shiftKey) {
            e.preventDefault();
            app.history.redo();
            return;
        }
        if(key === "y" && !e.shiftKey) {
            e.preventDefault();
            app.history.redo();
        }
    });
}
